import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { Dialog } from '@lean-body/components/molecules';
import { Button, ButtonType } from '../atoms';
import { StreakFreezeIcon } from '../atoms/icons/streak_freeze_icon';
export const StreakFreezeUsedYesterdayModal = ({ streakCount, onClickCancel }) => {
    return (React.createElement(Dialog, { onClickCancel: onClickCancel, classObject: styles.dialog, content: React.createElement("div", { className: css(styles.content) },
            React.createElement("div", { className: css(styles.body) },
                React.createElement(StreakFreezeIcon, { classObject: styles.freezeIcon }),
                React.createElement("div", { className: css(styles.title) },
                    React.createElement("span", { className: css(styles.highlightBlue) }, "\u30D5\u30EA\u30FC\u30BA"),
                    "\u3092\u4F7F\u7528\u3057\u3066",
                    React.createElement("span", { className: css(styles.highlightOrange) },
                        streakCount,
                        "\u65E5\u9023\u7D9A\u8A18\u9332"),
                    "\u304C\u5B88\u3089\u308C\u305F\u3088\uFF01")),
            React.createElement(Button, { className: css(styles.button), buttonType: ButtonType.blue, onClick: onClickCancel, isRadius: true, fullWidth: true }, "\u4ECA\u65E5\u3082\u304C\u3093\u3070\u308B\uD83D\uDCAA")) }));
};
const styles = StyleSheet.create({
    dialog: {
        position: 'absolute',
        top: 'unset',
        bottom: 0,
        backgroundColor: Colors.White,
        left: 'none',
        transform: 'none',
        width: '100%',
        borderRadius: '14px 14px 0 0',
        [MediaBreakPointUp.MD]: {
            position: 'relative',
            top: '30%',
            width: 375,
            margin: 'auto',
            borderRadius: 14,
        },
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
        padding: '32px 24px',
    },
    body: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 16,
    },
    freezeIcon: {
        width: 134,
        height: 120,
    },
    title: {
        color: Colors.TextDark,
        textAlign: 'center',
        fontSize: 20,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: 1.6,
    },
    highlightBlue: {
        color: Colors.Blue,
    },
    highlightOrange: {
        color: Colors.Orange,
    },
    button: {
        fontSize: 16,
    },
});
